import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ArtVarianteEsolver} from "../../../_models/ArtVarianteEsolver";
import {SaveMessage} from "../../../_helpers/save-message";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {ArticoliService} from "../../../_services/articoli.service";

@Component({
  selector: 'app-articolo-variante-input',
  templateUrl: './articolo-variante-input.component.html',
  styleUrls: ['./articolo-variante-input.component.scss'],
})
export class ArticoloVarianteInputComponent  {
  @Input() codArt = '';
  @Input() codVariante = '';
  @Output() codVarianteChange = new EventEmitter<string>();
  varianti: ArtVarianteEsolver[] = [];
  showList = false;
  loading = false;
  constructor(
    private saveMessage: SaveMessage,
    private organizzazioneService: OrganizzazioniService,
    private articoliService: ArticoliService) { }

  getVarianti() {
    this.showList = !this.showList;
    if (!this.showList) {
      this.varianti = [];
      return false;
    }
    this.loading = true;
    this.articoliService.searchVariantiOfArticolo(this.organizzazioneService.organizzazioneId, this.codArt)
      .then(response => this.varianti = response.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento delle varianti."))
      .finally(() => this.loading = false);
  }

  selectVariante = (variante: ArtVarianteEsolver) => {
    this.showList = false;
    this.codVariante = variante.varianteArt;
    this.codVarianteChange.emit(variante.varianteArt);
  };
  
}
